import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Award, Trophy, Sparkles, Target } from "lucide-react";

export default function Celebration() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/dashboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const stories = [
    { name: "PGD Restauração", text: "Três novos discípulos batizados neste trimestre. Vidas restauradas pela graça!" },
    { name: "PGD Jovem Conexão", text: "Grupo multiplicou e formou um novo líder. Colheita abundante entre os jovens." },
    { name: "PGD Águas Lindas", text: "Frequência acima de 90% há 6 semanas. Comunhão que transforma." },
  ];

  return (
    <div className="space-y-8 animate-fade-up" data-testid="celebration-page">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">Mural de Celebração</h1>
        <p className="text-muted-foreground mt-1">Reconhecimento de líderes comprometidos e histórias de transformação.</p>
      </div>

      <Card className="p-8 relative overflow-hidden bg-gradient-to-br from-accent/10 to-primary/10 border-accent/30">
        <Trophy className="h-14 w-14 text-accent mb-4" />
        <h2 className="font-display text-2xl font-bold">Grupos destaque do mês</h2>
        <p className="text-muted-foreground mt-1">PGDs que superaram a meta de 75% de frequência.</p>
        <div className="mt-6 flex flex-wrap gap-3" data-testid="celebration-highlights">
          {data?.above_75?.length ? data.above_75.map((g) => (
            <div key={g.name} className="flex items-center gap-3 rounded-xl border border-[hsl(var(--emerald))]/30 bg-card px-5 py-4" data-testid="celebration-leader-card">
              <Award className="h-6 w-6 text-[hsl(var(--emerald))]" />
              <div>
                <div className="font-semibold">{g.name}</div>
                <Badge className="bg-[hsl(var(--emerald))]/15 text-[hsl(var(--emerald))] border-none mt-1" data-testid="celebration-badge-75-percent">
                  <Target className="h-3 w-3 mr-1" /> {g.rate}% de frequência
                </Badge>
              </div>
            </div>
          )) : <p className="text-muted-foreground">Em breve, os primeiros destaques aparecerão aqui.</p>}
        </div>
      </Card>

      <div>
        <h2 className="font-display text-xl font-semibold mb-4 flex items-center gap-2"><Sparkles className="h-5 w-5 text-accent" /> Histórias de transformação</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {stories.map((s) => (
            <Card key={s.name} className="p-6">
              <Badge variant="secondary" className="mb-3">{s.name}</Badge>
              <p className="text-sm leading-relaxed">{s.text}</p>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
